/* eslint-disable consistent-return */

import _ from 'lodash';

import { getProductWeight } from 'shared/helpers/products';
import { orderProductsForDiscountPrecedence } from '../utilities';
import { getAvailableQuantity, determineWinningCombo, setSatisfiersToWinningCombo } from './common';
import getTotalProductCombinations from './get-total-product-combinations';

// TODO: perhaps make these parse in getProductWeight
const targetWeightToMg = {
  '.5g': 500,
  '.75g': 750,
  '1g': 1000,
  '1.25g': 1250,
  '1.5g': 1500,
  '1.75g': 1700,
  '2g': 2000,
  '2.25g': 2250,
  '2.5g': 2500,
  '2.75g': 2750,
  '3g': 3000,
  '3.25g': 3250,
  '3.5g': 3500,
  '3.75g': 3750,
  '4g': 4000,
  '1/8oz': 3500,
  '1/4oz': 7000,
  '1/2oz': 14000,
  '1oz': 28000,
  '1 1/8oz': 31500,
  '1 1/4oz': 35000,
  '1 1/2oz': 42000,
  '2oz': 56000,
};

const checkTotalWeight = ({
  bogoCalcsData,
  conditions,
  items,
  itemsForAPrice,
  itemToConsiderLast,
  logicOperator,
  pendingRewardsSatisfiers,
  specialId,
  specialsSettings,
  totalQuantity,
  totalWeight,
}) => {
  const { weight: weightTarget, weightOperator } = totalWeight;
  let satisfied = false;
  let satisfiers = {};

  const uniqueConditions = conditions.length > 0 ? _.uniqBy(_.flatMap(conditions, 'eligibleItems'), 'key') : items;
  const eligibleItems = orderProductsForDiscountPrecedence(
    uniqueConditions,
    specialsSettings,
    itemsForAPrice.enabled ? 'rewards' : 'conditions'
  );

  const availableEligibleItems = _.reduceRight(
    eligibleItems,
    (accumulator, item) => {
      // If item is weighted
      if (item?.weightInMg > 0) {
        const availableQuantity = getAvailableQuantity({
          item,
          bogoCalcsData,
          pendingConditionsSatisfiers: satisfiers,
          pendingRewardsSatisfiers,
          excludeDefeatedRewardsSatisfiers: itemsForAPrice?.enabled,
          specialId,
        });
        if (availableQuantity > 0) {
          accumulator.push({ item, key: item.key, quantity: availableQuantity, weightInMg: item.weightInMg });
        }
      }
      return accumulator;
    },
    []
  );

  if (availableEligibleItems.length < 1) {
    return { satisfied, satisfiers };
  }

  const weightTargetInMg = targetWeightToMg[weightTarget] ?? Number(getProductWeight(weightTarget) * 1000);

  const combinations = getTotalProductCombinations(
    availableEligibleItems,
    weightOperator,
    weightTargetInMg,
    totalQuantity
  );

  if (combinations.length < 1) {
    return { satisfied, satisfiers };
  }

  const winningCombination = determineWinningCombo(combinations, itemToConsiderLast, conditions, logicOperator);

  if (winningCombination) {
    satisfied = true;
    satisfiers = setSatisfiersToWinningCombo(winningCombination);
  }

  return { satisfied, satisfiers };
};

export default checkTotalWeight;
